import React from 'react';
import { Link } from 'react-router-dom';
import Slider from 'react-slick';
import EmoticonIcon from 'mdi-react/EmoticonIcon';
import CrosshairsGpsIcon from 'mdi-react/CrosshairsGpsIcon';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import Panel from '../../../../../shared/components/Panel';

const settings = {
  dots: false,
  infinite: true,
  speed: 500,
  autoplay: false,
  swipeToSlide: true,
  slidesToScroll: 1,
  responsive: [
    { breakpoint: 992, settings: { slidesToShow: 1 } },
    { breakpoint: 1200, settings: { slidesToShow: 1 } },
    { breakpoint: 1536, settings: { slidesToShow: 1 } },
    { breakpoint: 100000, settings: { slidesToShow: 1 } },
  ],
};

const InternalPromotion = ({ t }) => (
  <Panel md={12} lg={12} xl={6} sm={12} xs={12} noButtons>
    <Slider {...settings} className="dashboard__carousel interal__promotion">
      <div>
       <Link to={`/community-center`}>
        <div className="dashboard__carousel-slide slide__link">
          <EmoticonIcon />
          <p className="dashboard__carousel-title">Community Center<br/><span className="light-text smaller-text">Get Expert Insights</span></p>
          <p>Advice and insights from the our community of real estate professionals.</p>
        </div>
        </Link>
      </div>
    </Slider>
  </Panel>
);

InternalPromotion.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(InternalPromotion);
